module.exports = __webpack_public_path__ + "static/img/noData.90e9b72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/noData.png
// module id = cABt
// module chunks = 39